const state = {
    displayHeader: false,
    dark: localStorage.getItem('dark') ? localStorage.getItem('dark') === 'true' : false
};
const actions = {
    showHeader({commit}) {
        commit('showHeader')
    },
    hideHeader({commit}) {
        commit('hideHeader')
    },
    switchDark({commit}) {
        commit('switchDark')
    }
};

const getters = {
    getDisplayHeader: state => {
        return state.displayHeader
    },
    getDark: state => {
        return state.dark
    }
};

const mutations = {
    showHeader(state) {
        state.displayHeader = true
    },
    hideHeader(state) {
        state.displayHeader = false
    },
    switchDark(state) {
        state.dark = !state.dark
        localStorage.setItem('dark', state.dark)
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
